export const STORE_LOADING = 'STORE_LOADING'
export const STORE_PROFILE_USER = 'STORE_PROFILE_USER'
export const STORE_PROFILE_USER_DETAILS = 'STORE_PROFILE_USER_DETAILS'
export const STORE_PROFILE_USER_PHOTO = 'STORE_PROFILE_USER_PHOTO'
export const STORE_PROFILE_USER_NAME = 'STORE_PROFILE_USER_NAME'
export const STORE_CONFIRM_STATUS = 'STORE_CONFIRM_STATUS'
export const STORE_INCREMENT = 'STORE_INCREMENT'
export const STORE_DECREMENT = 'STORE_DECREMENT'
export const STORE_LOGIN = 'STORE_LOGIN'
export const STORE_LOGOUT = 'STORE_LOGOUT'
export const STORE_CHANGE_PASSWORD = 'STORE_CHANGE_PASSWORD'
export const STORE_CENTER = 'STORE_CENTER'
export const STORE_SET_FULL_BANNER = 'STORE_SET_FULL_BANNER'
export const STORE_HEADER = 'STORE_HEADER'
export const STORE_HEADER_OBJ = 'STORE_HEADER_OBJ'
export const STORE_CHILDREN_OBJ = 'STORE_CHILDREN_OBJ'
export const STORE_CHILDREN = 'STORE_CHILDREN'
export const STORE_ARRAY = 'STORE_ARRAY'
export const STORE_NEXT = 'STORE_NEXT'
export const STORE_PREVIOUS = 'STORE_PREVIOUS'
export const STORE_NAVIGATE = 'STORE_NAVIGATE'
export const STORE_UPDATE_INDEX = 'STORE_UPDATE_INDEX'
export const STORE_HEADER_INIT = 'STORE_HEADER_INIT'
export const STORE_CLEAR_ALL = 'STORE_CLEAR_ALL'
export const STORE_SET_LANG_PREF = 'STORE_SET_LANG_PREF'
export const STORE_CLEAR_CONTENT_ALL = 'STORE_CLEAR_CONTENT_ALL'
export const STORE_PARAMS_INIT = 'STORE_PARAMS_INIT'
export const STORE_CONTENT_HEADER_LOADER = 'STORE_CONTENT_HEADER_LOADER'
export const STORE_CONTENT_VIEWER_INIT = 'STORE_CONTENT_VIEWER_INIT'
export const STORE_SET_FRAMEWORK_CONFIG = 'STORE_SET_FRAMEWORK_CONFIG'
export const STORE_CONTENT_VIEWER_RESET_TIMER = 'STORE_CONTENT_VIEWER_RESET_TIMER'
export const STORE_CONTENT_VIEWER_INCREMENT_TIMER = 'STORE_CONTENT_VIEWER_INCREMENT_TIMER'
export const STORE_CONTENT_VIEWER_SET_INTERVALID = 'STORE_CONTENT_VIEWER_SET_INTERVALID'
export const STORE_CONTENT_VIEWER_SET_VISIT_DETAILS = 'STORE_CONTENT_VIEWER_SET_VISIT_DETAILS'
export const STORE_CONTENT_VIEWER_SET_LAST_VISITED_DETAILS = 'STORE_CONTENT_VIEWER_SET_LAST_VISITED_DETAILS'
export const STORE_CONTENT_VIEWER_SET_LANGUAGE = 'STORE_CONTENT_VIEWER_SET_LANGUAGE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js